import { IDashboardComponent, IDashboardMetadata } from '../dashboard-metadata.service';
import { IReportAggregates } from '../../../../shared/report/report-data.service';
import { SalesDashboardInfoComponent } from '../info/sales-dashboard-info.component';
import { CustomerDashboardFiltersComponent } from '../filters/customer/customer-dashboard-filters.component';
import { VALIDATOR_FN_CUSTOMER } from '../dashboard.service';

const columns:string[] = [
  'Delamcn',
  'Delamcm',
  'Delamnm',
  'Desprnm',
  'Decatav_ds',
  'Deoppor_ds',
  'Delamst_ds',
  'Deforus',
  'Decredt',
  'Decouco',
  'Deopeni',
  'Mxprodt',
  'Dedecdt',
  'Degbdmn',
  'Destaco'
];

const aggregates:IReportAggregates = {
  count: true,
  sum: true
};

const infoComponent:IDashboardComponent = {
  name: SalesDashboardInfoComponent
};

export const SALES_DASHBOARD_CONFIG:IDashboardMetadata = {
  title: 'SALES DASHBOARD',
  filterComponent: {
    name: CustomerDashboardFiltersComponent,
    inputs: {
      showLamContact: true,
      showWebshopPhase: true,
      prefilledWebshopPhaseValue: true,
      validatorFn: VALIDATOR_FN_CUSTOMER
    }
  },
  mapping: {
    Desprst_ds: 'webshopPhase.id',
    Decurce: 'currency.id',
    Desprnm: 'customer.id',
    Cucomnm: 'customerCompany.id',
    Delamnm: 'lam.id',
    Delamcm: 'lamCompany.id',
    Delamcn: 'lamContact.id',
    Lagrpnm: 'lamGroup.id',
    Degbdmn: 'gbdm.id',
    Decouid: 'country.id',
    Devincl: 'vatIncl.id'
  },
  fixedFilters: {
    Decurce: 'EUR',
    Devincl: '0'
  },
  reports: [
    {
      browselistCode: 'WEBSHOP_INFO',
      key: 'TOTAL_LEADS',
      code: 'TOTAL_LEADS',
      columns,
      aggregates,
      infoComponent
    },
    {
      browselistCode: 'WEBSHOP_INFO',
      key: 'LAM_COMPANIES_OPEN_LEADS',
      columns: [
        {
          name: 'Delamcm',
          groupingSequence: 1
        },
        {
          name: 'Desprnm',
          aggregate: 'cnt'
        },
        {
          name: 'Deforus',
          aggregate: 'sum'
        },
        {
          name: 'Deopeni',
          aggregate: 'sum'
        },
        {
          name: 'Delamnm',
          aggregate: 'cnt'
        },
        {
          name: 'Delamcn',
          aggregate: 'cnt'
        }
      ]
    },

    {
      browselistCode: 'WEBSHOP_INFO',
      key: 'LAMS_OPEN_LEADS',
      columns: [
        {
          name: 'Lam_description',
          label: 'LAM',
          groupingSequence: 1
        },
        {
          name: 'Desprnm',
          aggregate: 'cnt'
        },
        {
          name: 'Deforus',
          aggregate: 'sum'
        },
        {
          name: 'Deopeni',
          aggregate: 'sum'
        },
        {
          name: 'Delamcn',
          aggregate: 'cnt'
        }
      ]
    },

    {
      browselistCode: 'WEBSHOP_INFO',
      key: 'LAM_CONTACTS_OPEN_LEADS',
      columns: [
        {
          name: 'Delamcn',
          groupingSequence: 1
        },
        {
          name: 'Desprnm',
          aggregate: 'cnt'
        },
        {
          name: 'Deforus',
          aggregate: 'sum'
        },
        {
          name: 'Deopeni',
          aggregate: 'sum'
        }
      ]
    },

    {
      browselistCode: 'WEBSHOP_INFO',
      key: 'LAM_COMPANIES_OPEN_ITEMS',
      fixedFilters: {
        Deopeni: '>0'
      },
      columns: [
        {
          name: 'Delamcn',
          groupingSequence: 1
        },
        {
          name: 'Desprnm',
          aggregate: 'cnt'
        },
        {
          name: 'Deforus',
          aggregate: 'sum'
        },
        {
          name: 'Deopeni',
          aggregate: 'sum'
        }
      ]
    },

    {
      browselistCode: 'WEBSHOP_INFO',
      key: 'LEADS_WITH_CATALOG',
      code: 'LEADS_WITH_CATALOG',
      comments: '',
      fixedFilters: {
        Decatav_ds: '1'
      },
      columns,
      aggregates,
      infoComponent
    },

    {
      browselistCode: 'WEBSHOP_INFO',
      key: 'LEADS_WITHOUT_CATALOG',
      code: 'LEADS_WITHOUT_CATALOG',
      comments: '',
      fixedFilters: {
        Decatav_ds: '0'
      },
      columns,
      aggregates,
      infoComponent
    },

    {
      browselistCode: 'WEBSHOP_INFO',
      key: 'CLEAR_NEED',
      code: 'CLEAR_NEED',
      comments: '',
      fixedFilters: {
        Deoppor_ds: 'NEED'
      },
      columns,
      aggregates,
      infoComponent
    },

    {
      browselistCode: 'WEBSHOP_INFO',
      key: 'INQUIRY',
      code: 'INQUIRY',
      comments: '',
      fixedFilters: {
        Deoppor_ds: 'INQUIRY'
      },
      columns,
      aggregates,
      infoComponent
    },

    {
      browselistCode: 'WEBSHOP_INFO',
      key: 'RFP',
      code: 'RFP',
      comments: '',
      fixedFilters: {
        Deoppor_ds: 'RFP'
      },
      columns,
      aggregates,
      infoComponent
    },

    {
      browselistCode: 'WEBSHOP_INFO',
      key: 'CUSTOMER_OF_LAM',
      code: 'CUSTOMER_OF_LAM',
      comments: '',
      fixedFilters: {
        Delamst_ds: 'CUSTOMER'
      },
      columns,
      aggregates,
      infoComponent
    },

    {
      browselistCode: 'WEBSHOP_INFO',
      key: 'TARGET_OF_LAM',
      code: 'TARGET_OF_LAM',
      comments: '',
      fixedFilters: {
        Delamst_ds: 'TARGET'
      },
      columns,
      aggregates,
      infoComponent
    },

    {
      browselistCode: 'WEBSHOP_INFO',
      key: 'WON',
      code: 'WON',
      comments: '',
      fixedFilters: {
        Dewinch_ds: 'WON'
      },
      columns,
      aggregates,
      infoComponent
    },

    {
      browselistCode: 'WEBSHOP_INFO',
      key: 'HIGH',
      code: 'HIGH',
      comments: '',
      fixedFilters: {
        Dewinch_ds: 'HIGH'
      },
      columns,
      aggregates,
      infoComponent
    },

    {
      browselistCode: 'WEBSHOP_INFO',
      key: 'MEDIUM',
      code: 'MEDIUM',
      comments: '',
      fixedFilters: {
        Dewinch_ds: 'MEDIUM'
      },
      columns,
      aggregates,
      infoComponent
    },

    {
      browselistCode: 'WEBSHOP_INFO',
      key: 'LOW',
      code: 'LOW',
      comments: '',
      fixedFilters: {
        Dewinch_ds: 'LOW'
      },
      columns,
      aggregates,
      infoComponent
    },

    {
      browselistCode: 'WEBSHOP_INFO',
      key: 'TOP_LEADS',
      code: 'TOP_LEADS',
      comments: 'Clear need, with catalog, high win chance, LAM customer',
      fixedFilters: {
        Decatav_ds: '1',
        Deoppor_ds: 'NEED',
        Delamst_ds: 'CUSTOMER',
        Dewinch_ds: 'HIGH'
      },
      columns,
      aggregates,
      infoComponent
    }
  ]
};